import type { TrendMonth } from '@eriko/shared-types';
import { TrendChart, TrendChartSkeleton } from './TrendChart';

interface ReportsTrendSectionProps {
  trend: TrendMonth[];
  loading: boolean;
}

export function ReportsTrendSection({ trend, loading }: ReportsTrendSectionProps) {
  return (
    <section className="bg-surface-0/60 border border-surface-300/70 rounded-[6px] px-8 py-7 mb-12">
      <div className="flex items-start justify-between mb-6">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[2px] text-surface-600 mb-2">
            SIX-MONTH TREND
          </div>
          <h2 className="font-serif text-[22px] tracking-tight text-surface-900">
            <span className="italic font-normal">Revenue</span> versus{' '}
            <span className="italic font-normal">Expenses</span>
          </h2>
        </div>
        <div className="flex items-center gap-5 font-mono text-[10px] uppercase tracking-[1.5px] text-surface-600">
          <span className="flex items-center gap-2">
            <span className="inline-block w-2.5 h-2.5 rounded-sm bg-neg" />
            Revenue
          </span>
          <span className="flex items-center gap-2">
            <span className="inline-block w-2.5 h-2.5 rounded-sm bg-olive" />
            Expenses
          </span>
        </div>
      </div>
      {loading ? <TrendChartSkeleton /> : <TrendChart data={trend} />}
      <p className="mt-5 pl-5 relative text-[12px] italic text-surface-500 font-serif before:content-[''] before:absolute before:left-0 before:top-[0.7em] before:w-3 before:h-px before:bg-surface-400">
        Months without activity are shown as dashed outlines — a reminder of the quiet between clients.
      </p>
    </section>
  );
}
